import React from 'react'
import styles from './ExpandoCard.scss'
import {ParticipantCard} from './GoalCards'
import {CircleSpinner} from 'common/spinners'
import {List} from 'immutable'
import * as goalParticipantActions from 'lib/api/goalParticipants'
import {connect} from 'react-redux'
import {SmallTripList} from 'common/SmallTripList'
import {FormattedMessage as T} from 'react-intl'

export class ExpandoCard extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      loaded: false,
      expanded: false
    }
  }

  toggleTrips = () => {
    const {loaded, expanded} = this.state
    const {loadParticipantTrips, goalParticipant} = this.props
    this.setState({expanded: !expanded})
    if (this.props.trips.size > 0) {
      this.setState({loaded: true})
      return
    }
    if (!loaded) {
      loadParticipantTrips(goalParticipant.get('id'))
        .then(() => {
          this.setState({loaded: true})
        })
    }
  }

  onToggleExclude = (tripId) => {
    const {trips, goal, goalParticipant, excludeTrip, unexcludeTrip, loadParticipantsForGoal} = this.props
    const goalId = goal.get('id')
    const trip = trips.trips.find((t) => t.get('id') === tripId)
    const action = trip.get('is_excluded')
      ? unexcludeTrip(goalParticipant.get('id'), tripId)
      : excludeTrip(goalParticipant.get('id'), tripId)
    action.then(() => {
      // after (un)excluding trip, re-load goal participants to grab updated
      // progress, rank, trailer
      loadParticipantsForGoal(goalId)
      loadParticipantsForGoal(goalId, {friends: true})
    })
  }

  render () {
    const {expanded, loaded} = this.state
    const {trips, currentUserId, goalParticipant, goal, loadParticipantTrips} = this.props
    const showExclude = (
      currentUserId === goalParticipant.getIn(['user', 'id']) || goal.get('current_user_is_admin')
    )
    const actionLink = (
      <a onClick={this.toggleTrips} className={styles.expandoButton}>
        {expanded
          ? <T id='ExpandoCard.hideTrips' defaultMessage='Hide Trips' />
          : <T id='ExpandoCard.showTrips' defaultMessage='Show Trips' />}
      </a>
    )

    const tripsList = trips.get('trips')
    const nextPage = trips.get('nextPage', -1)
    const participantId = goalParticipant.get('id')

    return <ParticipantCard {...this.props} className={styles.ExpandoCard} actionLink={actionLink}>
      {expanded && <div className={styles.expando}>
        {!loaded && <CircleSpinner className={styles.spinner} centered size={25} />}
        {loaded && <SmallTripList trips={tripsList} showExclude={showExclude} toggleExclude={this.onToggleExclude} nextPage={nextPage} loading={trips.get('loading')} participantId={participantId} loadParticipantTrips={loadParticipantTrips} />}
      </div>}
    </ParticipantCard>
  }
}

const mapStateToProps = (state, ownProps) => {
  const gpId = ownProps.goalParticipant.get('id')

  return {
    trips: state.goalParticipants.trips.get(gpId, List()),
    participantId: state.goalParticipants.participantId,
    currentUserId: state.currentUser.id
  }
}

const mapDispatchToProps = {
  loadParticipantTrips: goalParticipantActions.loadParticipantTrips,
  excludeTrip: goalParticipantActions.excludeTrip,
  unexcludeTrip: goalParticipantActions.unexcludeTrip,
  loadParticipantsForGoal: goalParticipantActions.loadParticipantsForGoal
}

export const ExpandoCardContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ExpandoCard)
